import { SizeProp } from "@fortawesome/fontawesome-svg-core"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Typography } from "@mui/material"
import { useTheme } from "@mui/material/styles"
import React from "react"
import { IFormCardButtonProps, themeShade } from "./FormCardButton.interfaces"
import { StyledBox, StyledCard, StyledIconBox } from "./FormCardButton.styled"
import { changeLanguage } from "i18next"
import { fontAwesomeOldXlStyle } from "components/icons/fontAwesomeStyles"

// library.add(fas)

const GetColor = (shade: themeShade, colorType: string) => {
  const theme = useTheme()
  switch (colorType) {
    case "primary":
      return theme.palette.primary[shade]
    case "success":
      return theme.palette.success[shade]
    case "warning":
      return theme.palette.warning[shade]
    case "error":
      return theme.palette.error[shade]
    default:
      return theme.palette.primary[shade]
  }
}

const FormCardButton: React.FC<IFormCardButtonProps> = (props) => {
  const { title, size, description, iconColor, icon, handleClick, option, translationData, t, defaultValue } = props;
  const theme = useTheme()

  return (
    <StyledCard onClick={() => handleClick && handleClick(option)}>
      <StyledBox color={GetColor(themeShade.light, iconColor || "primary")}>
        <StyledIconBox mb={2} color={GetColor(themeShade.main, iconColor || "primary")}>
          {icon && <FontAwesomeIcon color={(theme.palette as any).primary[700]} size={size ? (size as SizeProp) : undefined} style={size ? undefined : fontAwesomeOldXlStyle} icon={icon} />}
        </StyledIconBox>
        <Typography mb={1} variant="h4" color="textPrimary">
          {translationData?.formTypeKey ? t(translationData?.formTypeKey + ".form_key." + translationData.formNameKey, defaultValue) : title}
        </Typography>
        <Typography color="text.secondary">{description ? t(description, description) : description}</Typography>
      </StyledBox>
    </StyledCard>
  );
};

export default FormCardButton;

